<script setup lang="ts">
import { watch } from 'vue';
import { Icon } from '@iconify/vue';
import { useTheme } from 'vuetify';
import { useCustomizerStore } from '@/stores/customizer';

const customizer = useCustomizerStore();
const theme = useTheme();

const themeColors = [
  {
    name: 'BLUE_THEME',
    bg: 'togglethemeBlue',
    icon: 'solar:sun-2-line-duotone',
  },
  {
    name: 'DARK_BLUE_THEME',
    bg: 'togglethemeDarkBlue',
    icon: 'solar:moon-line-duotone',
  },
];

watch(
  () => customizer.actTheme,
  (nextTheme) => {
    theme.global.name.value = nextTheme;
  },
  {
    immediate: true,
  },
);

function setTheme(name: string) {
  customizer.SET_THEME(name);
}
</script>

<template>
  <div class="position-relative">
    <v-item-group
      v-model="customizer.actTheme"
      mandatory
      class="theme-toggle-group"
    >
      <div
        v-for="option in themeColors"
        :key="option.name"
      >
        <v-item
          v-slot="{ toggle }"
          :value="option.name"
        >
          <v-sheet
            rounded="circle"
            class="cursor-pointer hover-btns"
            elevation="0"
            @click="toggle(); setTheme(option.name)"
          >
            <v-btn
              icon
              :class="option.bg"
              class="custom-hover-primary"
              size="small"
              variant="text"
              color="primary"
            >
              <Icon
                :icon="option.icon"
                :class="option.bg"
                height="22"
              />
            </v-btn>
          </v-sheet>
        </v-item>
      </div>
    </v-item-group>
  </div>
</template>

<style scoped lang="scss">
.theme-toggle-group {
  display: flex;
  gap: 6px;
  align-items: center;
}

.hover-btns {
  padding: 2px;
}
</style>
